import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { LuEye } from "react-icons/lu";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import WrapperBox from '../../../../_common/WrapperBox';
import Box from '@mui/material/Box';
import { Grid, IconButton }  from '@mui/material';
import { Stack } from '@mui/material';
import CustomText from '../../../../_common/CustomText';
import { 
    dnsDesignateRequest, 
    getXAuthTokenProjectScope } from 
'../../../../../_network/openstack_request';
import { zonesUrl as zoneUrlResponses } 
from '../../../../../_api_responses/openstack/dns/zones/v2';
import { openStackServices } from 
'../../../../../config/openStackConstants';
import { 
    dnsDesignateConstants
} from '../../../../../config/openStackConstants';
import CustomDialog from 
'../../../../_common/CustomDialog';

const SERVICE_NAME = openStackServices.dnsService

const detailTabCardConfig = {
    border: 0,
    borderBottom: 0.3,
    borderStyle: "dashed",
    borderBottomColor: "text.secondary",
    height: 100,
    minWidth: 150,
    alignItems: "start",
    pl: 3
}

const ZoneExportsV2 = (props) => {
    const { zoneExports } = props
    const { handleExportsFetch } = props
    const defaultTexts = useSelector(state => state.texts.langTexts)
    const defaultAdminProject = useSelector(state => state.profile.defaultAdminProject.id)
    const [error, setError] = useState();
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [selectedExport, setSelectedExport] = useState(null);
    const [exportDeleteConfirmDialogOpen, setExportDeleteConfirmDialogOpen] = useState(false)
    const [exportData, setExportData] = useState(null)
    const [exportDataDialogOpen, setExportDataDialogOpen] = useState(false)

    const theme = useTheme();

    const dnsServiceDomain = useSelector(
        state => state.openstack.purchasedServices.filter(
        service => service.service === SERVICE_NAME)[0].config_params.service_domain)
    const dnsServiceVersion = useSelector(
        state => state.openstack.purchasedServices.filter(
        service => service.service === SERVICE_NAME)[0].config_params.api_version)
    const zonesUrl = useSelector(
        state => state.dnsDesignate.dnsDesignateApiUrls.filter(
            version => version.api_version === "v2")[0].urls.filter(
                url => url.keyword === dnsDesignateConstants.zonesUrl)[0].url)
   

    const common_url = `${dnsServiceDomain}/${dnsServiceVersion}/${zonesUrl}/tasks/exports`

    const handleExportDataDialogClose = () => {
        setExportData(null)
        setExportDataDialogOpen(false)
    }

    const handleExportDataDialogOpen = () => {
        setExportDataDialogOpen(true)
    }

    const handleErrorDialogClose = () => {
        setError(null);
        setErrorDialogOpen(false);
    }

    const handleExportConfirmDeleteDialogOpen = (rec) => {
        setSelectedExport(rec)
        setExportDeleteConfirmDialogOpen(true)
    }

    const handleExportDeleteConfirmDialogClose = () => {
        setSelectedExport(null)
        setExportDeleteConfirmDialogOpen(false)
    }

    const handleExportDownload = async (rec) => {
        const project_token = await getXAuthTokenProjectScope(defaultAdminProject)
        if (project_token) {
            const method = "GET"
            const zone_response = await dnsDesignateRequest({
                url: `${common_url}/${rec.id}/export`, 
                method: method,
                headers: {"Accepts": "text/dns"},
                token: project_token
            })
            if (zone_response.status_code === zoneUrlResponses.get.success_response.status_code) {
                setExportData(zone_response.data)
                handleExportDataDialogOpen()
            } else {
                setError(zone_response.error)
            }
        }
    }

    const onZoneExportDelete = async () => {
        const project_token = await getXAuthTokenProjectScope(defaultAdminProject)
        if (project_token) {
            const method = "DELETE"
            const zone_response = await dnsDesignateRequest({
                url: `${common_url}/${selectedExport.id}`, 
                method: method, 
                token: project_token
            })
            if (zone_response.status_code === zoneUrlResponses.delete_sync.success_response.status_code) {
                handleExportDeleteConfirmDialogClose()
                handleExportsFetch()
            } else {
                setError(zone_response.error)
            }
        }
    }

    return (
        <React.Fragment>
            <WrapperBox
                sx={detailTabCardConfig}
            >
                <Stack
                    direction="row" 
                    alignItems="center" 
                    justifyContent="center"
                    spacing={2}
                > 
                    <CustomText 
                        size="p" 
                        sx={{fontSize: {xs: 16, lg: 18}}}
                    >
                        {defaultTexts.zoneRecordsetsTitleText}
                    </CustomText>
                    <CustomText 
                        size="h5" 
                        sx={{
                            color: theme.palette.dashboardPink
                        }}
                    >
                        {zoneExports.length}
                    </CustomText>
                </Stack>
            </WrapperBox>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TableContainer >
                        <Table sx={{ width: "100%" }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">{defaultTexts.locationFormFieldLabel}</TableCell>
                                    <TableCell align="left">{defaultTexts.statusFormFieldLabel}</TableCell>
                                    <TableCell align="left">{defaultTexts.versionFormFieldLabel}</TableCell>
                                    <TableCell align="left">{defaultTexts.createTimeHeaderLabel}</TableCell>
                                    <TableCell align="left">{defaultTexts.updatedAtFormFieldLabel}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {zoneExports.map((row) => (
                                <TableRow
                                    key={row.id}
                                >
                                    <TableCell 
                                        align="left"
                                    >
                                        {<IconButton
                                            onClick={() => handleExportDownload(row)}
                                        >
                                            <LuEye
                                                style={{color: theme.palette.primary.main}}
                                            />
                                        </IconButton>}
                                        {<IconButton
                                            onClick={() => handleExportConfirmDeleteDialogOpen(row)}
                                        >
                                            <DeleteIcon 
                                                color="error"
                                            />
                                        </IconButton>}
                                    </TableCell>
                                    <TableCell 
                                        component="th"
                                        align="left"
                                        scope="row"
                                    >
                                        <Box sx={{
                                            width: 200, 
                                            wordWrap: "break-word"
                                        }}>
                                            {row.location}
                                        </Box>
                                    </TableCell>
                                    <TableCell 
                                        align="left"
                                    >
                                        {row.status}
                                    </TableCell>
                                    <TableCell 
                                        align="left"
                                    >
                                        {row.version}
                                    </TableCell>
                                    <TableCell 
                                        align="left"
                                    >
                                        {new Date(row.created_at).toLocaleString()}
                                    </TableCell>
                                    <TableCell 
                                        align="left"
                                    >
                                        {row.updated_at ? new Date(row.updated_at).toLocaleString() : "-"}
                                    </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
            </Grid>
        </Grid>
        <CustomDialog
                open={exportDeleteConfirmDialogOpen}
                onClose={handleExportDeleteConfirmDialogClose}
                dialogTitle={{
                    title: defaultTexts.zoneExportDeleteConfirmTitle, 
                    sx: {color: 'primary.main'}}}
                dialogBody={{
                    text: `${defaultTexts.zoneExportDeleteConfirmText}: [${selectedExport && selectedExport.id}]`, 
                    sx: {color: 'text.primary'}}}
                actionButtons={[{
                    title: defaultTexts.confirmButtonText, 
                    onClick: onZoneExportDelete,
                    sx: {color: 'primary.main'}}]}
            />
        {exportData && <CustomDialog
            open={exportDataDialogOpen}
            onClose={handleExportDataDialogClose}
            dialogTitle={{
                title: defaultTexts.zoneExportDataDetailsTitle, 
                sx: {color: 'primary.main'}}}
            dialogBody={{
                text: `<pre>${exportData}</pre>`, 
                sx: {color: 'text.primary'}}}
            maxWidth="lg"
        />}
        {error && <CustomDialog
            open={errorDialogOpen}
            onClose={handleErrorDialogClose}
            dialogTitle={{
                title: defaultTexts.failedActionErrorDialogTitle, 
                sx: {color: 'primary.main'}}}
            dialogBody={{
                text: `<span>${defaultTexts.failedActionErrorDialogMessage}</span>
                        <br>
                        <br>
                        <span>${defaultTexts.detailsErrorNoteDialogText}:</span> 
                        <span style="color: orange">
                            ${error}
                        </span>`, 
                sx: {color: 'text.primary'}}}
        />}
        </React.Fragment>
    )
};

export default ZoneExportsV2;